import styled from 'styled-components';

export const FooterWrapper = styled.div`
  display: flex;
  align-items: baseline;
  /* background: #f5f5f5; */
  border-radius: 0 0 8px 8px;
  gap: 10px;
  .emp-ant-form-item {
    margin-bottom: 0;
  }
`;
